import AbstractSlopedRightRectangle from "./AbstractSlopedRightRectangle";

export default class SlopedRightRectangleFlipVertical extends AbstractSlopedRightRectangle {
	static NAME = "sloped-right-rectangle-flip-vertical";

	get_name() {
		return SlopedRightRectangleFlipVertical.NAME;
	}
}
